import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const OfficeLocation = () => {
  const [activeOffice, setActiveOffice] = useState(0);

  const offices = [
    {
      id: 1,
      name: "Shutter Lifters",
      address: "C-20, 1/1A, Coast Guard Golf Ground Rd, C Block, Phase 2, Industrial Area, Sector 62",
      city: "Noida, Uttar Pradesh 201309",
      phone: "+91 7579505033",
      email: "connect@shutterlifters.com",
      hours: "Mon-sat: 10:00 AM - 7:00 PM IST",
      timezone: "Indian Time",
      lat: "28.614632136528716",
      lng: "77.35524845219722",
      features: ["Main Office", "Client Meeting Rooms", "Development Team"],
      image: "https://lh3.googleusercontent.com/p/AF1QipMN_rDCOR13jdhE8HDELOR1Y4vWxYXjD5LSiU7q=s1360-w1360-h1020-rw"
    },
    // {
    //   id: 2,
    //   name: "New York Studio",
    //   address: "456 Tech Avenue, Floor 12",
    //   city: "New York, NY 10001",
    //   phone: "+1 (555) 987-6543",
    //   email: "ny@shutterlifters.com",
    //   hours: "Mon-Fri: 9:00 AM - 6:00 PM EST",
    //   timezone: "Eastern Time",
    //   lat: "40.7128",
    //   lng: "-74.0060",
    //   features: ["Design Studio", "Client Presentations", "Creative Team"],
    //   image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=400&fit=crop"
    // },
    // {
    //   id: 3,
    //   name: "Austin Branch",
    //   address: "789 Startup Boulevard, Building C",
    //   city: "Austin, TX 78701",
    //   phone: "+1 (555) 456-7890",
    //   email: "austin@shutterlifters.com",
    //   hours: "Mon-Fri: 9:00 AM - 6:00 PM CST",
    //   timezone: "Central Time",
    //   lat: "30.2672",
    //   lng: "-97.7431",
    //   features: ["Innovation Lab", "Startup Partnerships", "R&D Team"],
    //   image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&h=400&fit=crop"
    // }
  ];

  const contactInfo = [
    {
      icon: "Phone",
      label: "Call Us",
      value: "+91 7579505033",
      description: "Available 24/7 for urgent matters"
    },
    {
      icon: "Mail",
      label: "Email Us",
      value: "connect@shutter-lifters.in",
      description: "Response within 2 hours"
    },
    {
      icon: "MessageCircle",
      label: "Live Chat",
      value: "Available Now",
      description: "Instant support during business hours"
    },
    {
      icon: "MapPin",
      label: "Visit Us",
      value: "At",
      description: "Alt.F,Noida, Uttar Pradesh 201309"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            Our
            <span className="text-accent"> Locations</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Visit us at any of our offices or connect with us virtually. We're here to help bring your vision to life.
          </p>
        </motion.div>

        {/* Quick Contact Info */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {contactInfo?.map((info, index) => (
            <motion.div
              key={index}
              className="bg-card border border-border rounded-xl p-6 text-center group hover:border-accent/50 transition-all duration-300"
              whileHover={{ scale: 1.05, boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)" }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <motion.div
                className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-accent/20 transition-colors duration-300"
                whileHover={{ rotateY: 180 }}
                transition={{ duration: 0.6 }}
              >
                <Icon name={info?.icon} size={24} className="text-accent" />
              </motion.div>
              <h3 className="font-semibold text-foreground mb-2">{info?.label}</h3>
              <p className="text-accent font-medium mb-1">{info?.value}</p>
              <p className="text-sm text-muted-foreground">{info?.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Office Locations */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Office List */}
          <motion.div
            className="lg:col-span-1"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-2xl font-bold text-foreground mb-6">Choose Location</h3>
            <div className="space-y-4">
              {offices?.map((office, index) => (
                <motion.button
                  key={office?.id}
                  onClick={() => setActiveOffice(index)}
                  className={`w-full text-left p-4 rounded-xl border transition-all duration-300 ${
                    activeOffice === index
                      ? 'bg-accent/10 border-accent shadow-accent'
                      : 'bg-card border-border hover:border-accent/50'
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                >
                  <div className="flex items-start space-x-3">
                    <div className={`w-3 h-3 rounded-full mt-2 ${
                      activeOffice === index ? 'bg-accent' : 'bg-muted-foreground'
                    }`} />
                    <div className="flex-1">
                      <h4 className="font-semibold text-foreground mb-1">{office?.name}</h4>
                      <p className="text-sm text-muted-foreground mb-2">{office?.city}</p>
                      <div className="flex flex-wrap gap-1">
                        {office?.features?.slice(0, 2)?.map((feature) => (
                          <span
                            key={feature}
                            className="px-2 py-1 bg-muted/30 text-muted-foreground text-xs rounded-md"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.button>
              ))}
            </div>
          </motion.div>

          {/* Office Details & Map */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="bg-card border border-border rounded-2xl overflow-hidden">
              {/* Office Image */}
              <div className="relative h-64 overflow-hidden">
                <motion.img
                  key={activeOffice}
                  src={offices?.[activeOffice]?.image}
                  alt={offices?.[activeOffice]?.name}
                  className="w-full h-full object-cover"
                  initial={{ scale: 1.2, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.8 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    {offices?.[activeOffice]?.name}
                  </h3>
                  <p className="text-white/80">{offices?.[activeOffice]?.city}</p>
                </div>
              </div>

              {/* Office Info */}
              <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <Icon name="MapPin" size={20} className="text-accent mt-1" />
                      <div>
                        <p className="font-medium text-foreground">Address</p>
                        <p className="text-sm text-muted-foreground">
                          {offices?.[activeOffice]?.address}<br />
                          {offices?.[activeOffice]?.city}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <Icon name="Phone" size={20} className="text-accent mt-1" />
                      <div>
                        <p className="font-medium text-foreground">Phone</p>
                        <p className="text-sm text-muted-foreground">
                          {offices?.[activeOffice]?.phone}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <Icon name="Mail" size={20} className="text-accent mt-1" />
                      <div>
                        <p className="font-medium text-foreground">Email</p>
                        <p className="text-sm text-muted-foreground">
                          {offices?.[activeOffice]?.email}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <Icon name="Clock" size={20} className="text-accent mt-1" />
                      <div>
                        <p className="font-medium text-foreground">Hours</p>
                        <p className="text-sm text-muted-foreground">
                          {offices?.[activeOffice]?.hours}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <Icon name="Globe" size={20} className="text-accent mt-1" />
                      <div>
                        <p className="font-medium text-foreground">Timezone</p>
                        <p className="text-sm text-muted-foreground">
                          {offices?.[activeOffice]?.timezone}
                        </p>
                      </div>
                    </div>

                    <div>
                      <p className="font-medium text-foreground mb-2">Features</p>
                      <div className="flex flex-wrap gap-2">
                        {offices?.[activeOffice]?.features?.map((feature) => (
                          <span
                            key={feature}
                            className="px-3 py-1 bg-accent/10 text-accent text-sm rounded-full"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Map */}
                <div className="h-64 rounded-lg overflow-hidden border border-border">
                  <iframe
                    width="100%"
                    height="100%"
                    loading="lazy"
                    title={offices?.[activeOffice]?.name}
                    referrerPolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps?q=${offices?.[activeOffice]?.lat},${offices?.[activeOffice]?.lng}&z=14&output=embed`}
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OfficeLocation;